import script from "./UploadOption.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadOption.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/upload.css?vue&type=style&index=0&id=75b8e2b8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b8e2b8"]])

export default __exports__